export enum FilterEnums {
  REQUEST = "request",
  TRAINING = "training",
  LEARNING_PATH = "learning_path",
  HABILITATION = "habilitation",
}
